export default "__VITE_ASSET__aeec5871__"